import { BaseDialog } from "@ui/Dialogs/BaseDialog";
import useDialogStore from "@store/useDialogStore";

export function ThankYouDialog() {
  const { closeDialog } = useDialogStore();

  return (
    <BaseDialog
      showHeader={false}
      secondaryButton={{
        label: "Cancel",
        callback: () => closeDialog(),
      }}
    >
      <div className="min-h-[232px] flex flex-col justify-center items-center gap-5 px-4 pt-4 text-center">
        <h2 className="text-xl font-semibold dark:text-invertedPrimary80">Thank you</h2>
        <p className="text-sm text-content-secondary dark:text-invertedPrimary80">
          Your input helps improve
          <br />
          the system over time
        </p>
      </div>
    </BaseDialog>
  );
}
